import React from "react";
import styles from "./../../assets/styles/_slideProduct.module.scss";
import thumbProduct1 from "../../assets/images/productPage/product-bottle.png";
import thumb1Product1 from "../../assets/images/productPage/product-bottle1.png";
import thumb2Product1 from "../../assets/images/productPage/product-bottle2.png";
import thumb3Product1 from "../../assets/images/productPage/product-bottle3.png";
import thumb4Product1 from "../../assets/images/productPage/product-bottle4.png";
import thumb5Product1 from "../../assets/images/productPage/product-bottle5.png";
import thumbProduct2 from "../../assets/images/productPage/thumbProduct2.png";
import thumb1Product2 from "../../assets/images/productPage/thumb1Product2.png";
import thumb2Product2 from "../../assets/images/productPage/thumb2Product2.png";
import thumb3Product2 from "../../assets/images/productPage/thumb3Product2.png";
import thumb4Product2 from "../../assets/images/productPage/thumb4Product2.png";
import thumb5Product2 from "../../assets/images/productPage/thumb5Product2.png";
import Slider from "react-slick"; // Import thư viện react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BtnLearnMore from "../common/btnLearnMore";
import FadeInSection from "../common/FadeInSection";
import { useNavigate } from "react-router-dom";

const SlideProduct = () => {
  const navigate = useNavigate();

  const settings = {
    infinite: true, // Lặp lại vô hạn
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    // autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true, // Cho phép vuốt đến bất kỳ slide nào
    touchThreshold: 10, // Giúp cải thiện độ nhạy khi vuốt
    responsive: [
      {
        breakpoint: 1024, // Khi màn hình nhỏ hơn 768px
        settings: {
          slidesToShow: 3, // Hiển thị 3 slide
        },
      },
      {
        breakpoint: 800, // Khi màn hình nhỏ hơn 577px
        settings: {
          slidesToShow: 2, // Hiển thị 2 slide
        },
      },
    ],
  };
  const products = [
    {
      id: 1,
      thumb: thumbProduct1,
      title1: "ウォーターコートシャンプー",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product1,
      title1: "ウォーターコートトリートメント",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product1,
      title1: "ウォーターコートヘアオイル",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product1,
      title1: "ウォーターコートヘアミルク",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product1,
      title1: "ウォーターコートシャンプー",
      title2: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product1,
      title1: "ウォーターコートトリートメント",
      title2: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380g",
    },
    {
      id: 1,
      thumb: thumbProduct2,
      title1: "ウォーターコートシャンプー",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product2,
      title1: "ウォーターコートトリートメント",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product2,
      title1: "ウォーターコートヘアオイル",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product2,
      title1: "ウォーターコートヘアミルク",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product2,
      title1: "ウォーターコートシャンプー",
      title2: "スリークモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product2,
      title1: "ウォーターコートトリートメント",
      title2: "スリークモイスト",
      capacity: "1,210",
      volume: "380g",
    },
  ];
  return (
    <div className={styles.slideProducts}>
      <div className={styles.slideProductsTitle}>PRODUCT</div>
      <div className={styles.slideProductsDetail}>
        <Slider {...settings}>
          {products.map((slide) => (
            <>
              <div className={styles.slideProductsItem}>
                <img src={slide.thumb} alt={slide.title1} />
                <div className={styles.slideProductsItemTitle}>
                  <a href="/">{slide.title1}</a>
                </div>
                <div className={styles.slideProductsItemCate}>
                  {slide.title2}
                </div>
                {/* <div
                  className={`${styles.slideProductsItemCate} ${styles.hairOilMb}`}
                >
                  HAIR OIL
                </div> */}
              </div>
            </>
          ))}
        </Slider>
      </div>

      <FadeInSection>
        <div className={styles.btn}>
          <BtnLearnMore
            color="#5CCEFF66"
            baseColor="#5CCEFF"
            action={() => navigate("/products")}
          >
            LEARN MORE
          </BtnLearnMore>
        </div>
      </FadeInSection>
    </div>
  );
};

export default SlideProduct;
